import {
  DUCTED_RESULT_SETS,
  DuctedCompatibilityEntry,
  DuctedCompatibilityState
} from './ducted-compatibility-slice';

// Soft-readiness signal for the Choose Systems pre-warm (AHA-6681 sub-build
// 5, ruling: SOFT). Purely informational — consumers render a spinner/check
// from it and must NEVER gate navigation on it (the tab/footer stay
// clickable in every state).
export type DuctedReadiness = 'idle' | 'loading' | 'ready';

// Derived from the (systemUniqueId, resultSet) combinations entries:
// 'idle'    = nothing to report — no entries yet (pre-warm hasn't fired), or
//             a set ended in error (an honest check would overclaim);
// 'loading' = at least one fetch in flight;
// 'ready'   = every entry settled honestly (loaded, or a recorded skip).
export function deriveDuctedReadiness(
  resultsBySystem: DuctedCompatibilityState['resultsBySystem']
): DuctedReadiness {
  const entries: DuctedCompatibilityEntry[] = [];
  Object.values(resultsBySystem).forEach((bySet) => {
    DUCTED_RESULT_SETS.forEach((resultSet) => {
      const entry = bySet[resultSet];
      if (entry) entries.push(entry);
    });
  });
  if (entries.length === 0) return 'idle';
  if (entries.some((entry) => entry.status === 'loading')) return 'loading';
  return entries.every(
    (entry) => entry.status === 'loaded' || entry.status === 'skipped'
  )
    ? 'ready'
    : 'idle';
}
